// The homepage lazy-loads the login modal; other layouts import it statically.
// A click on a login/sign-up button before the lazy chunk has arrived would do nothing
// visible, so callers ask here and fall back to the /signup page instead.
let lazyModalPageMounted = false;
let lazyModalLoaded = false;

// Ready unless a page that lazy-loads the modal is showing and its chunk is still missing.
export const isLoginModalReady = () => !lazyModalPageMounted || lazyModalLoaded;

// The homepage calls this from an effect: true on mount, false in the cleanup,
// so the other layouts are never left waiting on a chunk they do not use.
export const setLazyLoginModalPage = (mounted) => {
    lazyModalPageMounted = mounted;
};

// Wraps the import function handed to next/dynamic; the chunk counts as loaded once it resolves.
export const trackLazyLoginModal = (load) => () =>
    load().then((mod) => {
        lazyModalLoaded = true;
        return mod;
    });

// Same destination as the header's no-JS form: /signup, in login mode for Login.
// Keeps the current query string so UTM params survive, like the inline script in _document.js.
export const goToSignupPage = (isLogin) => {
    const params = new URLSearchParams(window.location.search);
    if (isLogin) params.set('mode', 'login');
    const query = params.toString();
    window.location.assign(`/signup${query ? `?${query}` : ''}`);
};
